import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import classNames from 'classnames';
import Moment from 'react-moment'
import moment from 'moment'

import agent from '../agent'
import { store, history } from '../store/configureStore'
import { push } from 'react-router-redux';
import artistType from '../data/artist-type';
import queryString from 'query-string'

import AgencyTalentRegistration from '../containers/AgencyTalentRegistration'
import UpdateProfileAgency from '../containers/UpdateProfileAgency'
import AMLogo from '../assets/images/audition-magic-favicon.png'
import UserPic from '../assets/images/Katie.O_Dell_copy.jpg'
import DummyPic from '../assets/images/1818_profile1_lg.jpg'
import UserDummy from '../assets/images/agency_no_pic_talent.png'

//These options are for both genders
import heightOptions from '../data/height-options';
import complexions from '../data/complexions';
import eyeColours from '../data/eye-colours';
import waistSizes from '../data/waist-sizes';
import hairColours from '../data/hair-colours';
import ethnicities from '../data/ethnicities';

//Female Adult Statistics Options
import bustSizes from '../data/bust-sizes';
import hipSizes from '../data/hip-sizes';
import femaleShoeSizes from '../data/female-shoe-sizes';
import femaleSuitSizes from '../data/female-suit-sizes';
import femaleDressSizes from '../data/female-dress-sizes';
import femaleBraSizes from '../data/female-bra-sizes';

//Male Adult Statistics Options
import chestSizes from '../data/chest-sizes';
import collarSizes from '../data/collar-sizes';
import maleShoeSizes from '../data/male-shoe-sizes';
import maleSuitSizes from '../data/male-suit-sizes';
import insideLegOptions from '../data/inside-leg-options';
import outsideLegOptions from '../data/outside-leg-options';

//Kids Statistics Options
import kidsShoeSizes from '../data/kid-shoe-sizes';
import kidsClothingOptions from '../data/kid-clothing-options';

// Measurements
import statRegion from '../data/stat-region'
import statUnits from '../data/stat-units'
import statAge from '../data/stat-age'

const Header = ({ agency, showMenu, handleLogout, handleShowMenu, token }) => (
	<div id="agency-wrapper" className="grid-x">
		<nav className="cell navbar-default">
			<div className="grid-x top-nav container-fluid">
				<div className="cell large-6 medium-6 small-12">
					<a className="home" href="/agencydashboard">
						<div className="navbar-header logo"></div>
					</a>
				</div>
				<div className="cell large-6 medium-6 small-12">
					<ul className="right-nav">
						<li><div className="user-info">
							<button onClick={handleShowMenu}>
								<h1>{agency.meta.first_name} {agency.meta.last_name}</h1>
								<img src={agency.meta.avatar.thumb.url || agency.photo_thumb}/>
								<span>
									<i className="fa fa-caret-down" />
								</span>
							</button>
							{
								console.log('header', showMenu)
							}
							{
								showMenu &&
									(<div className="row small-12 logout-menu logout-menu-adjustment">
										<i className="header-span1 column small-6 fa fa-sign-out"></i>
										<a className="header-span2 column small-6 end" onClick={handleLogout}>Log-out</a>
									</div>)
							}
						</div></li>
					</ul>
				</div>
			</div>
		</nav>
		{
		<nav className="cell project-nav">
			<h5 className="h5-adjust"><b>{agency.agency.name}</b></h5>
		</nav>
		}
		<nav className="cell action-nav">
			<ul className="action-nav tabs" data-tabs id="agency-selection-tabs">
              <li className="tabs-title is-active"><a id="talent-hover" aria-selected="true"><div className="talent-validation"></div>Talent</a></li>
              <li className="tabs-title"><a id="schedule-hover" aria-selected="false" href={"https://agency.auditionmagic.com/schedules?token=" + token } target="_blank"><div className="schedule-request"></div>Schedule Requests</a></li>
            </ul>
		</nav>
	</div>
	)

class AgencyDashboard extends Component {
	state = {
		//data: null,
		companyLink: [],
		company: null,	//dummy
		representation: null,
		toggleToViewAll: false,
		toggleToApproved: true,
		toggleAdd: false,
		toggleEdit: false,
		disableButton: false,
		company_id: 0,
		approved_class: 'cell approved-button-selected',
		viewall_class: 'cell viewall-button',
		addagency_class: 'cell add-button',
		approved_flag: true,
		viewall_flag: false,
		addagency_flag: false,
		artistInfo: {},
		showMenu: false,
		fullAgencyInfo: {},

		
	}
	componentWillMount() {
		this.getAllRequest('pending')
		console.log('componentWillMount')
	}

	componentDidMount() {
		// this.getAllRequest('pending')
		// console.log('componentDidMount')
	}

	showMenu = () => {
		this.setState({ showMenu: this.state.showMenu ? false : true })
	}

	logoutAritst = () => {
		this.props.history.push('/agent')
	}

	getAllRequest(values) {
		const { repList } = this.props
		const token = new URLSearchParams(this.props.location.search).get('token')
		const agencyInfo = this.props.location.state.agency;
		agent.Agency.agencyInfo(token).then((k) => {
			this.setState({ company_id: k.agency.id })
			this.setState({ fullAgencyInfo: k.agency })
		})
		const val = values == 'approved' ? 'synced' : values
		agent.Agency.representationRequest(token, val).then((k) => {
			// if (this.props.representation) {
			// 	this.props.representation.map((item, idx) => {
			// 		let company = item.artist.creator_id ? 
			// 			agent.Agency.companyDetails(item.artist.creator_id).then(k => this.setState({ company: k.company })) : 'Talent'
			// 		console.log('render-inner', company, this.state.company)
			// 	})
			// }
			var represent = []
			k.representation_requests.map((item, idx) => {
				// let company = item.artist.creator_id ?
				// 	agent.Agency.companyDetails(item.artist.creator_id)
				// 		.then((j) => {
				// 			let compLink = { company_id: item.artist.creator_id, company_name: j.company.name }
				// 			this.setState({ companyLink: [...this.state.companyLink, compLink] })
				// 		}) : 'Talent'
				let company = ''
				if (item.artist.creator_id) {
					let compLink = { company_id: item.artist.creator_id, company_name: agencyInfo.agency.name }
					this.setState({ companyLink: [...this.state.companyLink, compLink] })
				} else { company = 'Talent' }
				if (company === 'Talent') {
					let compLink = { company_id: 0, company_name: company }
					this.setState({ companyLink: [...this.state.companyLink, compLink] })
				}
				represent.push({ ...item, approved: val == 'synced', rejected: false, pending: val == 'pending' })
			})
			this.setState({
				representation: represent
			})
		})
		// const res = agent.Agency.representationRequest(token, 'synced')
		// return Promise.all([
		// 	repList(token, 'pending')
		// ])
	}

	mapCompanyName(id) {
		let agencyInfo = this.props.location.state.agency
		let thisId = id || 0;
		console.log('mapCompanyName', thisId, this.state.companyLink)
		// if (thisId != null || thisId != 0) {
		// 	return agencyInfo.agency.name;
		// }
		//return 'Talent-2'
		return this.state.companyLink.find(k => k.company_id == thisId) || { company_id: -1, company_name: '' }
	}

	parseDate(value) {
		console.log('parseDate', value)
		const timeNow = moment(value).format('DD MMM YYYY, h:mm:ss a')
		//const timeCode = moment.tz(timeNow, audition_event.time_zone).format('z')
		return timeNow;
	}

	localStartTime (startTime) {
	  	const localTime = moment.utc(startTime).toDate()
	  	return moment(localTime).format() // ISO 8601 format
	  }

	  timeRange2 (audition_event) {
	  	const localTime = this.localStartTime(audition_event.start_time)
	  	const startTime = moment.utc(localTime).format('h.mm a')
	  	const timeCode = moment.tz(localTime, audition_event.time_zone).format('z')
	  	if (parseInt(timeCode) >= 0)
	  		return `${startTime} (GMT ${timeCode})`
	  	return `${startTime} ${timeCode}`
	  }

	artist_action = (value, id) => {
		//I need a response to api with approved, rejected and pending flag
		var data = this.state.representation.find(k => k.id === id);
		console.log('artist_action_1', data, id, value)
		if (data) {
			if (value === 'approved') {
				data.approved = true; data.pending = false; data.rejected = false;
				this.approveArtist(id)
			}
			if (value === 'rejected') {
				data.approved = false; data.pending = false; data.rejected = true;
			}
			if (value === 'pending') {
				data.approved = false; data.pending = true; data.rejected = false;
			}
		}
		var included = this.state.representation.filter(k => k.id !== id)
		console.log('artist_action_2', included)
		included.push(data)
		console.log('artist_action_3', included)
		this.setState({
			representation: included
		})
	}

	approveArtist = id => {
		const { location, approved } = this.props
		const values = queryString.parse(location.search)
		console.log('artist_action_1-1', id, values)
		this.props.approved(id, values.token, id)
	}

	denyArtist = id => {
		const { location, deny } = this.props
		const values = queryString.parse(location.search)

		this.props.deny(id, values.token, id)
	}

	parseHeight = (value) => {
		const h = heightOptions.find(k => k.id === value)
		return h ? h.name : "";
	}

	changePage = (value, artist) => {
		console.log('changePage', value, artist)
		switch (value) {
			case 'approved':
				this.setState({ toggleToApproved: true, toggleToViewAll: false,
						toggleAdd: false, toggleEdit: false, 
						approved_class: 'cell approved-button-selected',
						viewall_class: 'cell viewall-button', addagency_class: 'cell add-button',
						approved_flag: !this.state.approved_flag,
						viewall_flag: false, addagency_flag: false })
				this.getAllRequest('pending')
				break;
			case 'viewall':
				this.setState({ toggleToApproved: false, toggleToViewAll: true,
					toggleAdd: false, toggleEdit: false, 
					viewall_class: 'cell viewall-button-selected',
					approved_class: 'cell approved-button', addagency_class: 'cell add-button',
					viewall_flag: !this.state.viewall_flag,
					approved_flag: false, addagency_flag: false })
				this.getAllRequest('approved')
				break;
			case 'add':
				this.setState({ toggleToApproved: false, toggleToViewAll: false,
					toggleAdd: true, toggleEdit: false, 
					addagency_class: 'cell add-button-selected',
					viewall_class: 'cell viewall-button', approved_class: 'cell approved-button',
					addagency_flag: !this.state.addagency_flag,
					approved_flag: false, viewall_flag: false })
				break;
			case 'edit':
				this.setState({ toggleToApproved: false, toggleToViewAll: false,
					toggleAdd: false, toggleEdit: true, artistInfo: artist })
				break;
		}
	}

	submit = (values, dispatch, props) => {
    
  	}

  	updateToggleAdd = (value) => {
  		console.log('updateToggleAdd', value, this.props)
  		this.setState({ toggleAdd: value })
  		history.push({
	      pathname: '/agencydashboard',
	      search: this.props.location.search
	    })
  	}

	handleShowMenu = (value) => {
		this.setState({ showMenu: this.state.showMenu ? false : true })
	}

	render() {
		const { artistInfo, location } = this.props
		const agencyInfo = this.props.location.state.agency
		console.log('render-agency', this.state.representation)
		const token = new URLSearchParams(this.props.location.search).get('token')
		const filterFix = {
			marginLeft: '0.5rem',
			color: '#008DEF',
			fontSize: '1.1rem'
		}
		const colorFix = {
			color: '#fff',
			marginTop: '0.1rem',

		}
		const colorFix2 = {
			color: '#008DEF',
			paddingTop: '7px',
			paddingLeft: '11px'
		}
		const colorFix3 = {
			color: '#008DEF'
		}
		const colorFix4 = {
			color: '#fff',
			paddingTop: '7px',
			paddingLeft: '11px'
		}
		const filterSideFix = {
			padding: '1.5rem 0.75rem',
    		backgroundColor: '#F5F3F3',
    		width: '3%'
		}
		const filterSideFix2 = {
			width: '97%'
		}
		const heightAdjust = {
			height: '100%'
		}
		const liAdjust = {
			// paddingLeft: '35rem',
    		paddingTop: '0.65rem'
		}
		const pFix = {
			marginBottom: '0'
		}
		const viewAdjust = {
			// paddingLeft: '40rem'
		}
		const apFix = {
			marginBottom: '0',
			fontSize: '1.1rem'
		}
		// const heightMax = {
		// 	height: '100%',
		// 	minWidth: '517px'
		// }
		const customSizing = {
			width: '37%'
		}
		const viewAllAjust = {
			paddingLeft: '1rem',
			paddingRight: '1rem',
			height: '44px'
		}
		const noPadding = {
			padding: '0'
		}
		const adjment = {
			width: '57px'
		}
		return (
			<div>
				<Header agency={agencyInfo} showMenu={this.state.showMenu} handleShowMenu={this.handleShowMenu} handleLogout={this.logoutAritst} token={token} />
				<div id="talent-validation-contents">
					<nav className="grid-x action-nav">
						<ul className="left-panel action-nav tabs set-bg cell" data-tabs id="agency-selection-sub-tabs">
			              <li className="tabs-title is-active">
			              	<a id="approve-agency" aria-selected={this.state.approved_flag} onClick={e => this.changePage('approved')}>
			              		<div id="approve-div" className="grid-x align-middle">
				              		<div className={this.state.approved_class}></div>
				              		<div className="cell small-5">approve</div>
				              		<div className="cell small-3">
					              		<span style={filterFix} className="fa-stack">
											<span className="fa fa-circle fa-stack-2x" aria-hidden="true"></span>
											<strong style={colorFix} className="fa-stack-1x">{this.state.representation ? this.state.representation.filter(k => k.pending).length : 0}</strong>
										</span>
									</div>
								</div>
			              	</a>
			              </li>
			              <li className="tabs-title">
			              	<a id="view-agency" aria-selected={this.state.viewall_flag} onClick={e => this.changePage('viewall')}>
			              		<div id="viewall-div" className="grid-x align-middle">
				              		<div className={this.state.viewall_class}></div>
				              		<div style={adjment} className="cell">view all</div>
				              	</div>
			              	</a>
			              </li>
			              <li className="tabs-title">
			              	<a id="add-agency" aria-selected={this.state.addagency_flag} onClick={e => this.changePage('add')}>
			              		<div id="addagency-div" className="grid-x align-middle">
			              			<div className={this.state.addagency_class}></div>
				              		<div className="cell small-3">add</div>
			              		</div>
			              	</a>
			              </li>
			            </ul>
			            <ul className="middle-panel action-nav tabs set-bg grid-x align-middle align-center">
			            	<li className="tabs-title">
			            		<p className="status-menu">
			            		{ this.state.fullAgencyInfo.synced_count }&nbsp;Approved Talent
			            		</p>
			            	</li>
			            </ul>
			            <ul className="right-panel action-nav tabs set-bg grid-x align-right">
			            	{
				            	/*<li className="tabs-title">
				            		<a className="grid-hover" aria-selected="false">
					              		<div></div>
					              	</a>
				            	</li>*/
			            	}
			            	<li className="tabs-title">
			            		<a className="card-hover" aria-selected="true">
				              		<div></div>
				              	</a>
			            	</li>
			            	{
				            	/*<li className="tabs-title">
				            		<a className="list-hover" aria-selected="false">
					              		<div></div>
					              	</a>
				            	</li>*/
			            	}
			            </ul>
					</nav>
					
					<div id="agency-selection-sub-tabs" className="grid-x set-min-height">
						{
							// (!this.state.toggleAdd || !this.state.toggleEdit) &&
							// 	(<div style={filterSideFix} className="cell">
							// 		<i className="fa fa-sliders fa-2x" aria-hidden="true"></i>
							// 	</div>)
						}
						{
							this.state.toggleAdd &&
								(<div className="cell cell-100 gray-bg">
								<div id="artist-list">
									<AgencyTalentRegistration {...this.props} 
											company_id={this.state.company_id}
											updateToggleAdd={this.updateToggleAdd} /></div></div>)
						}
						{
							this.state.toggleEdit &&
								(<div className="cell cell-100 gray-bg">
								<div id="artist-list">
									<UpdateProfileAgency artistInfo={this.state.artistInfo} /></div></div>)
						}
						<div className="cell cell-97">
							<div id="artist-list">
							{
								this.state.representation &&
								(this.state.representation.map((item, idx) => {
									const containerFix = {
										backgroundImage: `url(${item.artist.avatar_url || UserDummy})`
									}
									if (this.state.toggleToApproved) {
										if (item.pending) {
											return (<div key={idx + 1} className="artist-list-fix">
												<div className="row border">
													{/*<div className="column small-4 img-artist">
													</div>*/}
													<div style={containerFix} className="column small-4 img-artist">
														{ /*<img className="img-artist" src={item.artist.avatar_url || UserDummy} />*/ }
													</div>
													<div className="column small-7 artist-details-last">
														<p className="bold">{item.artist.first_name} {item.artist.last_name}</p>
														<p>{item.artist.gender}</p>
														{ /*(item.artist.age_from || item.artist.age_to) && <p>{item.artist.age_from} - {item.artist.age_to}</p>*/ }
														<p className="bold"><small>{item.artist.mobile_number}</small></p>
														<p className="bold"><small>{item.artist.email}</small></p>
														<div className="artist-creation">
															<p><small>Created by: {this.mapCompanyName(item.artist.creator_id).company_name}</small></p>
															<p><small>{this.parseDate(item.artist.created_at)}</small></p>
														</div>
														<div className="artist-action">
														{
															item.pending && <div>
																<button type="button" className="button secondary clear-button" value="approved" onClick={e => this.artist_action(e.target.value, item.id)}>Approve</button>&nbsp;&nbsp;
																<button type="button" className="button hollow alert clear-button" value="rejected" onClick={e => this.artist_action(e.target.value, item.id)}>Reject</button></div>
														}
														{
															item.rejected && <div>
																<button type="button" className="button alert clear-button">Rejected</button>&nbsp;&nbsp;
																<button type="button" className="button hollow success clear-button" value="pending" onClick={e => this.artist_action(e.target.value, item.id)}>Undo</button></div>
														}
														{
															item.approved && <div>
																<button type="button" className="button success clear-button">Approved</button>&nbsp;&nbsp;
																<button type="button" className="button hollow alert clear-button" value="pending" onClick={e => this.artist_action(e.target.value, item.id)}>Undo</button></div>
														}
														</div>
													</div>
												</div>
											</div>)
										} else { return (<div key={idx + 1}></div>) }
									} if (this.state.toggleToViewAll) {
										if (item.approved) {
											return (<div key={idx + 1} className="artist-list-fix">
												<div className="row border">
													{/*<div className="column small-4 img-artist">
													</div>*/}
													<div style={containerFix} className="column small-4 img-artist">
														{ /*<img className="img-artist" src={item.artist.avatar_url || UserDummy} />*/ }
													</div>
													<div style={noPadding} className="column small-7">
														<div className="column small-3 align-right align-to-right">Basic</div>
													</div>
													<div className="column small-7 artist-details-last">
														<p className="bold">{item.artist.first_name} {item.artist.last_name}</p>
														<p>{item.artist.gender}</p>
														<p>{item.artist.category}</p>
														<p className="bold"><small>{item.artist.mobile_number}</small></p>
														<p className="bold"><small>{item.artist.email}</small></p>
														{ 
															item.artist.statistics.height &&
																<div className="artist-creation-1">
																	<small><p>height: {this.parseHeight(item.artist.statistics.height)}</p></small>
																</div>
														}
													</div>
													{/*<div className="column small-7 artist-action-viewall">
														<div style={viewAllAjust} className="grid-x align-middle">
															<i className="cell small-2 action-button fa fa-comment-o fa-2" aria-hidden="true"></i>
															<i className="cell small-9 action-button fa fa-phone fa-2" aria-hidden="true"></i>
															<a style={noPadding} className="cell small-1" onClick={e => this.changePage("edit", item.artist)}><i className="action-button fa fa-pencil fa-2" aria-hidden="true"></i></a>
														</div>
													</div> */}
												</div>
											</div>)
										} else { return (<div key={idx + 1}></div>) }
									}
								}))
							}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

AgencyDashboard = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(AgencyDashboard)

const mapStateToProps = (state, ownProps) => {
	return ({
		represented: state.agency.represented,
		token: state.agency.token,
		representation: state.agency.representation,
		agencies: state.agency.agencies,
		isApproved: state.agency.isApproved
	})
}

const mapDispatchToProps = (dispatch) => ({
	repList: (token, status) =>
		dispatch({ type: 'REPRESENTATION_LIST', payload: agent.Agency.representationRequest(token, status) }),
	approved: (id, token, artist_id) =>
		dispatch({ type: 'AGENCY_ARTIST_APPROVE', payload: agent.Agency.representationApprove(id, token), artist_id }),
	deny: (id, token, artist_id) =>
		dispatch({ type: 'AGENCY_ARTIST_DENY', payload: agent.Agency.representationDeny(id, token), artist_id })
})


export default connect(mapStateToProps, mapDispatchToProps)(AgencyDashboard)


// WEBPACK FOOTER //
// ./src/containers/AgencyDashboard.js